<template>
  <section v-if="content">
    <div class="grid-2-col">
      <div class="image">
        <img src="img/team.webp" alt="Team" />
      </div>
      <div>
        <div class="label">{{ content.label }}</div>
        <h2>{{ content.title }}</h2>
        <div class="text">{{ content.text }}</div>

        <div class="btn">
          <MainButton :buttonText="$t('button.details')" targetRoute="vacancies" />
        </div>

       
      </div>
    </div>
  </section>
</template>

<script>
import MainButton from '@/components/Buttons/MainButton.vue'

export default {
  name: 'VacanciesSection',
  components: {
    MainButton
  },
  props: {
    content: {
      type: Object,
      required: true
    }
  }
}
</script>
